// eslint-disable-next-line jira/restricted/react
import React, { PureComponent, type MouseEvent } from 'react';
// eslint-disable-next-line jira/restricted/prop-types
import PropTypes from 'prop-types';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button/standard-button';
import { token } from '@atlaskit/tokens';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { FormattedMessage } from '@atlassian/jira-intl';
import errorStateImage from './error-state.svg';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ImageWrapper = styled.div({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	marginTop: token('space.500', '40px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TextWrapper = styled.div({
	margin: token('space.100', '8px'),
	display: 'flex',
	flexDirection: 'column',
	textAlign: 'center',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${gridSize * 40}px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HeaderWrapper = styled.h2({
	marginTop: token('space.300', '24px'),
});

type Props = {
	onRefresh: (arg1: MouseEvent<HTMLElement>) => void;
};

// eslint-disable-next-line jira/react/no-class-components
export class ProjectSettingsErrorScreen extends PureComponent<Props> {
	static propTypes = {
		onRefresh: PropTypes.func.isRequired,
	};

	render() {
		return (
			<ImageWrapper>
				<img alt="" src={errorStateImage} />
				<HeaderWrapper>
					<FormattedMessage
						id="project-settings.generic-error-state-header"
						defaultMessage="Something's gone wrong"
					/>
				</HeaderWrapper>
				<TextWrapper>
					<FormattedMessage
						id="project-settings.generic-error-state-text-first"
						defaultMessage="A problem prevented the page from loading."
					/>
					<FormattedMessage
						id="project-settings.generic-error-state-text-second"
						defaultMessage="Refresh and try again."
					/>
				</TextWrapper>
				<Button
					// @ts-expect-error - TS2322 - Type '{ children: Element; externalId: string; onClick: (arg1: MouseEvent<HTMLElement, MouseEvent>) => void; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'.
					externalId="project-settings.generic-error-refresh-button"
					onClick={this.props.onRefresh}
				>
					<FormattedMessage id="project-settings.refresh" defaultMessage="Refresh" />
				</Button>
			</ImageWrapper>
		);
	}
}
